























































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import BatchTemplatesForm from '@/views/app/management/settings/pages/facility/batch/components/BatchTemplatesForm.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ScrollView from '@/components/ScrollView.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import GenerationAlertModal from '../components/GenerationAlertModal.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'
import { StatementModule } from '@/store/modules/statement.module'
import { TemplateModule } from '@/store/modules/template.module'
import { EFacilityBlockableFeatures, EUserPermissions, EUserStatus, IFacility, IPayerType, IResident } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import { NoCache } from '@/decorators/NoCache'
import { getFacilityCompleteLevel } from '@/utils/facility/facilityLevels'
import { IBatchTemplate } from '@zunta/configurations/dist/types/template'

import BatchForm from '@/views/app/management/settings/pages/facility/batch/components/BatchForm.vue'

import Icon from '@/components/Icon.vue'

import { User } from '@/classes/User'
import Api from '@/api'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Switcher from '@/components/Switcher.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { PaymentsModule } from '@/store/modules/payments.module'
import { Debounce } from 'vue-debounce-decorator'
import Card from '@/components/Card.vue'
import GoBack from '@/components/GoBack.vue'
import Modal from '@/components/Modal.vue'
import Select from '@/components/Select.vue'
import { ISelectItem } from '@/interfaces'
import MultiSelectWrapped from '@/components/inputs/MultiSelectWrapped.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

@Component({
  components: {
    Modal,
    GoBack,
    Select,
    MultiSelectWrapped,
    Card,
    Switcher,
    SearchInput,
    Icon,
    BatchForm,
    ErrorMessages,
    ScrollView,
    Checkbox,
    BatchTemplatesForm,
    GenerationAlertModal
  }
})
export default class MailingsCreateBatch extends Vue {
  getFacilityCompleteLevel = (facility: IFacility) => getFacilityCompleteLevel({
    facility,
    users: this.users,
    facilitiesActivePayerTypesMap: this.facilitiesActivePayerTypesMap,
    contactListType: this.chainTypeOfContactListMap
  })
  user: User = Api.getUser() as User
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  EUserPermissions: any = EUserPermissions
  shouldShowGenerationAlert = false

  errors: string[] = []
  selectedFacilitiesWithPayers: any = {}

  facilitySearch: string = ''

  isValid: boolean = false
  showIncompleteFacilities: boolean = false
  showFormErrorsModal: boolean = false
  templatesUpdater: number = 1
  overflowContainer: boolean = true
  batchErrors: string[] = []
  incompleteFacilitiesErrors: string[] = []
  preValidate: boolean = false

  @NoCache
  get templateOptionsList () {
    return this.$store.state.template.templates
  }

  @NoCache
  get facilitiesList () {
    return this.$store.state.facility.facilities
  }

  get users () {
    return this.$store.state.user.users
  }

  get query () {
    return this.$route.query
  }

  get facilitiesListOptions () {
    return this.$store.state.facility.facilities.map((facility: IFacility) => {
      return {
        value: facility.id,
        key: facility.id,
        content: facility.shortName ? `${facility.name} | ${facility.shortName}` : facility.name,
        isComplete: this.getFacilityCompleteLevel(facility) === 100,
        isBlocked: this.isStatementGenAndMailBlocked(facility)
      }
    })
  }

  get chainTypeOfContactListMap (): { [k: string]: string[] } {
    return this.$store.state.resident.chainTypeOfContactListMap
  }

  get selectedFacilities () {
    return Object.values(this.selectedFacilitiesWithPayers).map((facility: any) => {
      return {
        value: facility.id,
        key: facility.id,
        content: facility.name,
        isComplete: this.getFacilityCompleteLevel(facility) === 100
      }
    })
  }

  get facilitiesActivePayerTypesMap (): { [k: string]: IPayerType[] } {
    return this.$store.state.facility.facilitiesActivePayerTypesMap || {}
  }

  get facilitiesPaymentsNotInSync () {
    return this.$store.state.payments.facilitiesPaymentsNotInSync
  }

  get facilitiesCompleteOrAll () {
    let facilities = this.facilitiesList
    if (!this.showIncompleteFacilities) {
      facilities = this.completeFacilitiesList
    }

    if (this.facilitySearch) {
      const lowerCaseSearch = this.facilitySearch.toLowerCase()
      facilities =
          facilities.filter((facility: IFacility) =>
              facility.name.toLowerCase().includes(lowerCaseSearch) ||
              (facility.shortName && facility.shortName.toLowerCase().includes(lowerCaseSearch))
          )
    }

    return facilities
  }

  get completeFacilitiesList () {
    return this.facilitiesList.filter((facility: IFacility) => (
        this.getFacilityCompleteLevel(facility) === 100
    ))
  }

  get incompleteFacilitiesList () {
    return this.facilitiesList.filter((facility: IFacility) => (
        this.getFacilityCompleteLevel(facility) < 100
    ))
  }

  get isAllSelected () {
    if (!this.facilitySearch) {
      return this.facilitiesCompleteOrAll.length === Object.keys(this.selectedFacilitiesWithPayers).length
    }
    for (const facility of this.facilitiesCompleteOrAll) {
      if (!this.selectedFacilitiesWithPayers[facility.id]) {
        return false
      }
    }
    return true
  }

  closeAlert () {
    this.shouldShowGenerationAlert = false
  }

  setOverflow (value: boolean) {
    this.overflowContainer = value
  }

  payerTypesForTemplates (facilityId: number | string) {
    const facility = this.selectedFacilitiesWithPayers[facilityId as number]
    if (facility.batch && facility.batch.payers && facility.batch.payers.length) {
      const filterArray = facility.batch.payers.concat(facility.batch.secondaryPayers ? facility.batch.secondaryPayers : []).map((item: any) => String(item))
      return this.facilitiesActivePayerTypesMap[facilityId]
          .filter((item: any) => filterArray.includes(String(item.id)))
    }
    return this.facilitiesActivePayerTypesMap[facilityId]
  }

  updatePresetId (facilityId: number | string, { settingsId, batchOrder }: any) {
    this.selectedFacilitiesWithPayers[facilityId].presetId = settingsId
    this.selectedFacilitiesWithPayers[facilityId].batchOrder = batchOrder !== null && batchOrder !== undefined ? batchOrder + 1 : null
    this.templatesUpdater = this.templatesUpdater + 1
    this.$forceUpdate()
  }

  toggleShowIncompleteFacilities () {
    this.showIncompleteFacilities = !this.showIncompleteFacilities
    if (!this.showIncompleteFacilities) {
      const filteredFacilities = Object.values(this.selectedFacilitiesWithPayers).filter(
          (facility: any) =>
              this.incompleteFacilitiesList.reduce((acc: any, next: any) => next.id !== facility.id, true)
      )
      const mappedFacilities: any = {}
      filteredFacilities.forEach((item: any) => {
        mappedFacilities[item.id] = item
      })
      this.selectedFacilitiesWithPayers = mappedFacilities
    }
  }

  allFacilityData (facility: IFacility) {
    return this.selectedFacilitiesWithPayers[facility.id as number]
  }

  isSelected (facility: IFacility): boolean {
    return !!this.selectedFacilitiesWithPayers[facility.id as number]
  }

  toggleSelectAll () {
    this.errors = []
    if (this.isAllSelected) {
      this.selectedFacilitiesWithPayers = {}
    } else {
      this.selectedFacilitiesWithPayers = {}
      this.facilitiesCompleteOrAll.forEach((facility: IFacility) => {
        this.toggleFacility(facility, true)
      })
    }
  }

  toggleFacilitySelectByResident (facility: IFacility) {
    let payload: any = {
      isResidentsBlockOpened: true
    }
    if (this.selectedFacilitiesWithPayers[facility.id as number].isResidentsBlockOpened) {
      payload = {
        isResidentsBlockOpened: false,
        isLoading: false,
        searchValue: '',
        residentOptions: {},
        selectedResidents: {},
        fetchData: false
      }
    }
    this.$set(this.selectedFacilitiesWithPayers, facility.id as number, {
      ...this.selectedFacilitiesWithPayers[facility.id as number],
      ...payload
    })
  }

  validateSettings () {
    const requiredKeys = [
      'monthsBack',
      'billingContact',
      'reviewUser',
      'dueDate',
      'zeroBalanceAction',
      'negativeBalanceAction',
      'controlBalanceAction',
      'printedStatementUser'
    ]
    let isValid = true
    this.batchErrors = []
    Object.values(this.selectedFacilitiesWithPayers).forEach((item: any) => {
      const keys = requiredKeys
      if (item.origin === 'NCS') {
        requiredKeys.push('ncsDirectDepositAction', 'ncsCollectionAction')
      }
      requiredKeys.forEach((key: string) => {
        if (key === 'controlBalanceAction' && !item['batch']['controlBalance']) {
          return
        }
        if (item['batch'][key] === null) {
          isValid = false
          this.batchErrors.push(this.getBatchFormErrors({
            facility: item.name,
            key
          }))
        }
      })
    })
    this.isValid = isValid
  }

  getBatchFormErrors (item: any): string {
    let text = item.facility ? `In batch form "${item.facility}"` : ''

    switch (item.key) {
      case 'monthsBack':
        text += ' field "Prior Months to Include" is required'
        break
      case 'billingDay':
        text += ' field "Statement Billing Date" is required'
        break
      case 'billingContact':
        text += ' field "Statement Billing Contact" is required'
        break
      case 'reviewUser':
        text += ' field "Statements are reviewed/mailed by" is required'
        break
      case 'dueDate':
        text += ' field "Statement Bill Due Date" is required'
        break
      case 'zeroBalanceAction':
        text += ' field "$0 balance statement" is required'
        break
      case 'negativeBalanceAction':
        text += ' field "Negative balance statement" is required'
        break
      case 'controlBalanceAction':
        text += ' field "Balance less than $___ statement" is required'
        break
      case 'printedStatementUser':
        text += ' field "Printed statements delivered by" is required'
        break
      case 'ncsDirectDepositAction':
        text += ' field "Resident is “In Collections” in NCS" is required'
        break
      case 'ncsCollectionAction':
        text += ' field "Payers for Residents that are set as Direct Dep/Facility/OPG in NCS" is required'
        break
    }
    return text
  }

  selectFacility (item: ISelectItem[]) {
    let id = 0
    if (item.length > Object.keys(this.selectedFacilitiesWithPayers).length) {
      id = item.map((el) => el.value).filter((obj) => Object.keys(this.selectedFacilitiesWithPayers).map((el) => parseInt(el)).indexOf(obj) === -1)[0]
    } else if (item.length) {
      id = Object.keys(this.selectedFacilitiesWithPayers).map((el) => parseInt(el)).filter((obj) => item.map((el) => el.value).indexOf(obj) === -1)[0]
    } else {
      this.selectedFacilitiesWithPayers = {}
      return
    }

    const facility = this.$store.state.facility.facilities.find((f: IFacility) => f.id === id)
    this.toggleFacility(facility)
  }

  async toggleFacility (facility: IFacility, force = false) {
    if (!facility || !facility.id || this.isStatementGenAndMailBlocked(facility)) {
      return
    }
    this.errors = []
    const exist = this.selectedFacilitiesWithPayers[facility.id as number]
    if (!exist) {
      const presets = await this.facilityModuleInstance.fetchFacilityAdvancedSettings(facility.id)
      const payload = {
        ...facility,
        id: facility.id,
        origin: facility.origin,
        name: facility.name,
        presets: presets,
        payersList: this.facilitiesActivePayerTypesMap[facility.id],
        presetId: null,
        batch: {
          monthsBack: null,
          payers: this.facilitiesActivePayerTypesMap[facility.id] ? this.facilitiesActivePayerTypesMap[facility.id].map((pt: IPayerType) => pt.id) : [],
          billingContact: null,
          reviewUser: null,
          reviewStatementsBeforeMailing: true,
          name: '',
          dueDate: null,
          zeroBalanceAction: null,
          negativeBalanceAction: null,
          controlBalance: null,
          controlBalanceAction: null,
          ncsCollectionAction: null,
          ncsDirectDepositAction: null,
          pccBillingCycleManager: undefined,
          printedStatementUser: null,
          secondaryPayers: [],
          payersToExclude: [],
          includePreviousBreakdown: false,
          includeAdjustmentsBreakdown: false,
          excludePaymentsWriteOff: false,
          includeAllPayers: true
        },
        isResidentsBlockOpened: false,
        isLoading: false,
        searchValue: '',
        residentOptions: {},
        selectedResidents: {},
        fetchData: false
      }
      this.$set(this.selectedFacilitiesWithPayers, facility.id as number, payload)
    } else if (!force) {
      this.$delete(this.selectedFacilitiesWithPayers, facility.id as number)
    }
    this.validateSettings()
  }

  saveSettingsForBatch (facility: IFacility, batch: any) {
    const updatePrimPayers = JSON.stringify(batch.payers) !== JSON.stringify(this.selectedFacilitiesWithPayers[facility.id as number].batch.payers)
    const updateSecondPayers = JSON.stringify(batch.secondaryPayers) !== JSON.stringify(this.selectedFacilitiesWithPayers[facility.id as number].batch.secondaryPayers)
    const updateBatch = batch.id !== this.selectedFacilitiesWithPayers[facility.id as number].batch.id
    if (updateBatch || updatePrimPayers || updateSecondPayers) {
      this.selectedFacilitiesWithPayers[facility.id as number].batch = batch
      this.templatesUpdater = this.templatesUpdater + 1
    } else {
      this.selectedFacilitiesWithPayers[facility.id as number].batch = batch
    }
    this.validateSettings()
    this.$forceUpdate()
  }

  updateBatchSettingsTemplates (facilityId: number, value: Partial<IBatchTemplate>[]) {
    this.selectedFacilitiesWithPayers[facilityId].templates = value && value.length ? value : null
    this.$forceUpdate()
  }

  async fetchStatements (facilities: any[]) {
    await this.statementModuleInstance.fetchFacilitiesStatements(facilities)
  }

  setFetchData (facility: IFacility, value: boolean) {
    this.selectedFacilitiesWithPayers[facility.id as number].fetchData = value
  }

  setResidentSearchValue (facility: IFacility, value: string) {
    this.selectedFacilitiesWithPayers[facility.id as number].searchValue = value
    this.fetchFacilityResidents(facility)
  }

  @Debounce(300)
  async fetchFacilityResidents (facility: IFacility, residentId: number = 0) {
    if (residentId) {
      this.selectedFacilitiesWithPayers[facility.id as number].selectedResidents[residentId] =
          await this.residentModuleInstance.fetchResidentById(residentId)
    } else {
      if (!this.selectedFacilitiesWithPayers[facility.id as number].searchValue) {
        return
      }
      const filters = {
        facilities: [(facility as IFacility).id as number],
        residentName: this.selectedFacilitiesWithPayers[facility.id as number].searchValue,
        limit: 1000,
        skip: 0
      }
      this.selectedFacilitiesWithPayers[facility.id as number].isLoading = true
      const res = await this.residentModuleInstance.getAndReturnResidentsFilteredList(filters)
      let residentPayload: any = {}
      res.forEach((resident: IResident) => {
        if (!this.selectedFacilitiesWithPayers[facility.id as number] ||
            !this.selectedFacilitiesWithPayers[facility.id as number].selectedResidents[resident.id as number]) {
          residentPayload[resident.id as number] = resident
        }
      })
      this.selectedFacilitiesWithPayers[facility.id as number].residentOptions = residentPayload
    }

    setTimeout(() => {
      this.selectedFacilitiesWithPayers[facility.id as number].isLoading = false
      this.$forceUpdate()
    }, 200)
  }

  addToSelectedResidents (facility: IFacility, resident: IResident) {
    this.selectedFacilitiesWithPayers[facility.id as number].selectedResidents[resident.id] = resident
    this.$delete(this.selectedFacilitiesWithPayers[facility.id as number].residentOptions, resident.id)
  }

  removeFromSelectedResidents (facility: IFacility, resident: IResident) {
    this.selectedFacilitiesWithPayers[facility.id as number].residentOptions[resident.id] = resident
    this.$delete(this.selectedFacilitiesWithPayers[facility.id as number].selectedResidents, resident.id)
  }

  setResidentLabel (resident: IResident) {
    return `${resident.firstName ? resident.firstName : ''} ${resident.lastName ? resident.lastName : ''} (${resident.ncsResidentId || resident.originid})`
  }

  async generate (confirmDepositPopup?: boolean) {
    this.shouldShowGenerationAlert = false
    const payload = Object.values(this.selectedFacilitiesWithPayers).map((item: any) => {
      const residents =
          Object.keys(this.selectedFacilitiesWithPayers[item.id as number].selectedResidents).length && item.isResidentsBlockOpened
              ? Object.keys(this.selectedFacilitiesWithPayers[item.id as number].selectedResidents)
                  .map((item: string | number) => Number(item))
              : null
      delete item['payersList']
      delete item['presets']
      delete item['presetId']
      delete item['isLoading']
      delete item['searchValue']
      delete item['residentOptions']
      delete item['selectedResidents']
      if (item['templates'] && !item['templates'].length) {
        delete item['templates']
      }

      if (!item.isResidentsBlockOpened || !(residents && residents.length)) {
        item['batch'].fetchData = true
      }
      // if (!item.fetchData || !item.isResidentsBlockOpened || !(residents && residents.length)) {
      //   delete item['fetchData']
      // }
      item['batchOrder'] = item['batchOrder'] !== null && item['batchOrder'] !== undefined ? item['batchOrder'] + 1 : null
      item['batch'].residents = residents
      item['batch'].fetchData = item.fetchData
      if (confirmDepositPopup) {
        item['batch'].recentDepositsConfirmedDate = new Date()
      }
      return {
        ...item,
        residents
      }
    })
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    await this.fetchStatements(payload)

    const facilities = Object.values(this.selectedFacilitiesWithPayers)
    let notificationMsg = ''
    facilities.forEach((f: any) => {
      notificationMsg += `${f.shortName || f.name || ''}; `
    })
    setTimeout(() => {
      this.$eventBus.$emit('loading:disable')
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: notificationMsg,
        header: `Statements Generating...`,
        icon: 'check'
      })
      this.goBack()
    }, 500)
  }

  async create () {
    if (!Object.keys(this.selectedFacilitiesWithPayers).length) {
      return
    }
    if (!this.isValid) {
      Object.keys(this.selectedFacilitiesWithPayers).forEach((key) => {
        [
          'monthsBack',
          'billingDay',
          'billingContact',
          'reviewUser',
          'dueDate'
        ].forEach((t) => {
          // @ts-ignore
          this.$refs['batchForm' + key][0].toggleSelect(t)
        })
      })
      this.showFormErrorsModal = true
      this.preValidate = true
      this.$forceUpdate()
      return
    }

    this.incompleteFacilitiesErrors = []
    Object.values(this.selectedFacilitiesWithPayers).forEach((f: any) => {
      if (this.getFacilityCompleteLevel(f) !== 100) {
        this.showFormErrorsModal = true
        this.incompleteFacilitiesErrors.push(`${f.name} is not complete`)
      }
    })
    if (this.incompleteFacilitiesErrors.length > 0) {
      return
    }
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    await this.paymentModuleInstance.fetchFacilityPaymentsNotInSync(this.selectedFacilitiesWithPayers)
    this.$eventBus.$emit('loading:disable')
    if (this.facilitiesPaymentsNotInSync.length > 0) {
      this.shouldShowGenerationAlert = true
      return
    }
    await this.generate()
  }

  goBack () {
    this.$router.push({ name: 'management-mailings' })
  }

  goFacilitySettings (facility: IFacility) {
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_FACILITIES)) {
      this.$locationManager.rememberAndGoTo({ name: 'management-facilities-settings-information', params: { id: `${facility.id}` } })
    }
  }

  async mounted () {
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    await this.facilityModuleInstance.getFacilityList({})
    await Promise.all([
      this.residentModuleInstance.fetchChainTypeOfContactListMap(),
      this.facilityModuleInstance.fetchFacilitiesActivePayerTypesMap(this.facilitiesList.map((facility: IFacility) => facility.id)),
      this.userModuleInstance.getManagementUsersList({
        status: EUserStatus.ACTIVE
      })
    ])
    // @ts-ignore
    await this.templateModuleInstance.fetchTemplates()
    setTimeout(async () => {
      this.$eventBus.$emit('loading:disable')
      if (this.query.facility) {
        const facility = this.facilitiesList.find((facility: IFacility) => {
          return (facility.id as number).toString() === this.query.facility.toString()
        })
        await this.toggleFacility(facility)
        if (this.query.resident) {
          await this.toggleFacilitySelectByResident(facility)
          await this.fetchFacilityResidents(facility, parseInt(this.query.resident as string))
        }
      }
    }, 400)
  }

  isStatementGenAndMailBlocked (facility: IFacility) {
    return isFacilityFeatureBlocked(facility, EFacilityBlockableFeatures.MailAndGenStatements)
  }
}
